import React, { Component } from "react";
import Logout from "../../assets/logout.svg";
import Back from "../../assets/back.svg";
// import RestaurantItem from '../../components/RestaurantItem'
import licenseplan from "../../assets/licenseplan.svg";
import { Modal } from "react-bootstrap";
// import { WhisperSpinner  } from "react-spinners-kit"
import { toast } from "react-toastify";
import CustomButton from "../../components/CustomButton";
import Tick from "../../assets/tick.svg";
import Cancel from "../../assets/cancel.svg";
import { NumericFormat } from "react-number-format";
import Loading from "../../components/Loading";
import "../../App1.css";
import { LogoutFunction } from "../../static.js";
import Tooltip from "@mui/material/Tooltip";

export default class LicensePlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataLoading: false,
      confirmLoading: false,
      licensePlans: [],
      ModalShow: false,
      currentItem: null,
      pageStatus: "normal",
      paymentToken: "",
    };

    this.paymentForm = React.createRef();
  }

  componentDidMount() {
    if (localStorage.getItem("token")) {
      this.setState({ dataLoading: true });
      fetch("https://94.101.187.196/api/BankPayment/GetLicensePlans", {
        method: "GET",
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
        .then((res) => {
          console.log(res);
          if (res.status === 401) {
            LogoutFunction();
          } else {
            return res.json();
          }
        })
        .then((result) => {
          console.log("GetLicensePlans: ", result);
          this.setState({ dataLoading: false, licensePlans: result.results });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      LogoutFunction();
    }
  }

  onBack() {
    this.props.history.push("/Restaurants");
  }

  onLogout() {
    LogoutFunction();
  }

  onClickToBuy(id) {
    this.state.licensePlans.forEach((element) => {
      if (element.id === id) {
        this.setState({ currentItem: element }, () => {
          this.setState({ ModalShow: true });
        });
      }
    });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  onConfirmToBuy() {
    this.setState({ dataLoading: true });

    if (this.state.currentItem.amount > 0) {
      fetch(
        "https://94.101.187.196/api/BankPayment/LicensePayment?licensePlanId=" +
          this.state.currentItem.id +
          "&restaurantId=" +
          this.props.match.params.id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => res.json())
        .then((result) => {
          console.log(result);

          if (result.isSuccessfull) {
            this.setState(
              {
                dataLoading: false,
                pageStatus: "payment",
                paymentToken: result.results[0].token,
              },
              () => {
                window.setTimeout(() => {
                  this.paymentForm.current.click();
                }, 1);
              }
            );
          } else if (result.errorMessage) {
            toast.error(result.errorMessage, {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
            this.setState({ dataLoading: false });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ dataLoading: false });
        });
    } else {
      this.setState({ ModalShow: false });
      fetch(
        "https://94.101.187.196/api/BankPayment/TrialLicensePayment?licensePlanId=" +
          this.state.currentItem.id +
          "&restaurantId=" +
          this.props.match.params.id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => res.json())
        .then((result) => {
          console.log(result);

          if (result.isSuccessfull) {
            toast.success("عملیات با موفقیت انجام شد", {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
            this.setState({ dataLoading: false });
          } else if (result.errorMessage) {
            toast.error(result.errorMessage, {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
            this.setState({ dataLoading: false });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ dataLoading: false });
        });
    }
  }

  render() {
    if (!this.state.dataLoading)
      if (this.state.pageStatus === "normal")
        return (
          <div className="Login">
            <div className="header">
              <div
                onClick={this.onBack.bind(this)}
                className="linkStyle backButton"
              >
                <img
                  src={Back}
                  alt=""
                  className="backButtonIcon"
                  style={{ transform: "rotate(180deg)" }}
                />
                بازگشت
              </div>
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
            <div className="LoginContent">
              <div className="RestaurantsListTitle">اشتراک</div>
              <div className="RestaurantsListSubTitle">خرید و تمدید اشتراک</div>

              <div
                style={{ width: "95vw", maxWidth: "1200px", marginTop: "20px" }}
              >
                <div className="grid">
                  {this.state.licensePlans.map((item, i) => {
                    return (
                      <div key={i} className="shopObjectContainer">
                        <div className="shopObjectItem">
                          <img
                            src={licenseplan}
                            alt=""
                            style={{
                              objectFit: "contain",
                              maxWidth: "100%",
                              maxHeight: "100px",
                            }}
                          />
                          <div
                            style={{
                              fontFamily: "SFUIDisplayBold",
                              fontSize: "16px",
                            }}
                          >
                            {item.name}
                          </div>
                          <NumericFormat
                            style={{
                              fontFamily: "SFUIDisplayBold",
                              fontSize: "16px",
                            }}
                            value={item.amount}
                            displayType={"text"}
                            thousandSeparator={true}
                            suffix={" ریال"}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              color: "var(--brown1)",
                            }}
                          >
                            مدت اعتبار:&nbsp;
                            <div>{item.timeSpanMonth}</div>
                            &nbsp;ماه
                          </div>
                          <CustomButton
                            title="خرید"
                            minHeight="35px"
                            onClick={this.onClickToBuy.bind(this, item.id)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <Modal
              show={this.state.ModalShow}
              size="sm"
              animation={true}
              onHide={this.hideModal.bind(this)}
              centered
            >
              {this.state.currentItem && (
                <div className="dialogBox">
                  آیا از خرید خود اطمینان دارید؟
                  <div
                    className="shopObjectItem"
                    style={{ marginTop: "20px", height: "140px" }}
                  >
                    {/* <img src={licenseplan} alt="" style={{objectFit: 'contain',maxWidth:'100%',maxHeight:'100px'}}/> */}
                    <div
                      style={{
                        fontFamily: "SFUIDisplayBold",
                        fontSize: "16px",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      نام اشتراک:&nbsp;{this.state.currentItem.name}
                    </div>
                    <div
                      style={{
                        fontFamily: "SFUIDisplayBold",
                        fontSize: "16px",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      مبلغ:&nbsp;
                      <NumericFormat
                        value={this.state.currentItem.amount}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={" ریال"}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        color: "var(--brown1)",
                        fontFamily: "SFUIDisplay",
                        fontSize: "14px",
                      }}
                    >
                      مدت اعتبار:&nbsp;
                      <div>{this.state.currentItem.timeSpanMonth}</div>
                      &nbsp;ماه
                    </div>
                    {/* <CustomButton title="خرید" minHeight="35px" onClick={this.onClickToBuy.bind(this,item.id)} /> */}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: "20px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flex: "1" }}>
                      <CustomButton
                        title="بله"
                        loading={this.state.confirmLoading}
                        imgHeight={20}
                        imgWidth={25}
                        minHeight="35px"
                        img={Tick}
                        onClick={this.onConfirmToBuy.bind(this)}
                      />
                    </div>
                    <div style={{ minWidth: "5px" }} />
                    <div style={{ flex: "0.8" }}>
                      <CustomButton
                        title="خیر"
                        imgHeight={19}
                        backColor="var(--black1)"
                        imgWidth={25}
                        minHeight="35px"
                        img={Cancel}
                        onClick={this.hideModal.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </Modal>
            {/* <ReactTooltip effect="solid" /> */}
          </div>
        );
      else
        return (
          <form
            style={{ display: "none" }}
            action="https://sep.shaparak.ir/OnlinePG/OnlinePG"
            method="post"
          >
            <input type="hidden" name="Token" value={this.state.paymentToken} />
            <input type="text" name="GetMethod" value="false" readOnly />
            <input
              ref={this.paymentForm}
              type="submit"
              name="submit"
              value="submit"
            />
          </form>
        );
    else return <Loading />;
  }
}
